import { ArrowUpRight } from "lucide-react";
import { Chapter, Stagger, StaggerItem } from "@/components/Reveal";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/i18n";

const Universe = () => {
  const { t } = useLang();
  const u = t.universe;

  return (
    <section id="universe" data-testid="universe-section" className="py-24 md:py-32">
      <div className="container-x">
        <Chapter num="05" label={u.chapter} />

        <h2 className="font-display text-4xl md:text-5xl lg:text-7xl uppercase tracking-tight leading-[0.9]">
          {u.titleA} <span className="text-[#D91624]">{u.titleB}</span>
        </h2>
        <p className="mt-6 max-w-2xl text-base md:text-lg text-neutral-400 leading-relaxed">
          {u.intro}
        </p>

        <Stagger className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {u.items.map((b) => (
            <StaggerItem key={b.id}>
              <article
                data-testid={`universe-card-${b.id}`}
                className="group h-full bg-[#121212] border border-white/10 flex flex-col hover:border-[#D4AF37]/40 transition-colors duration-500"
              >
                <div className="relative overflow-hidden aspect-[16/10]">
                  <img
                    src={b.img}
                    alt={b.title}
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/40" />
                  {b.id !== "community" && (
                    <span className="absolute top-4 left-4 bg-neutral-800 text-neutral-400 text-[10px] font-bold uppercase tracking-[0.2em] px-3 py-1.5">
                      {u.comingBadge}
                    </span>
                  )}
                </div>
                <div className="p-6 flex flex-col grow">
                  <p className="overline-gold !text-[10px]">{b.subtitle}</p>
                  <h3 className="font-display text-2xl md:text-3xl uppercase mt-2">{b.title}</h3>
                  <p className="mt-3 text-sm text-neutral-400 leading-relaxed grow">
                    {b.description}
                  </p>
                  {b.id === "community" ? (
                    <button
                      data-testid="universe-community-btn"
                      onClick={() => scrollToId("free-guide")}
                      className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37] hover:text-white transition-colors duration-300 cursor-pointer"
                    >
                      {u.communityCta} <ArrowUpRight size={14} />
                    </button>
                  ) : (
                    <span className="mt-6 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-neutral-600">
                      {u.notify}
                    </span>
                  )}
                </div>
              </article>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};

export default Universe;
